import React from "react";
import BudgetEntriesPage from "@/pages/BudgetEntriesPage";

export default function BudgetExpenseDefinitions() {
  return (
    <BudgetEntriesPage
      kind="gider"
      title="Gider Kayıtları"
      subtitle="Bütçe Yönetimi"
      testIdPrefix="expense"
    />
  );
}
